import { SD_PASSWORD_REQUIREMENTS } from "@sd/lib/sdPasswordRules";

export function PasswordRequirementsPanel() {
  return (
    <div className="rounded-xl bg-[#e8f3ff] px-4 py-3 text-[12.5px] leading-relaxed text-[#1d4f91]">
      <p className="mb-1.5 font-semibold">Password Requirements:</p>
      <ul className="list-disc space-y-0.5 pl-4">
        {SD_PASSWORD_REQUIREMENTS.map(rule => (
          <li key={rule}>{rule}</li>
        ))}
      </ul>
    </div>
  );
}
